import {createSelector} from '@ngrx/store';
import {AppState} from '../states/app.state';
import {identity} from 'rxjs';

export class PreviewDialogSelectors {
  private static select = {
    isOpen: (state: AppState) => state.previewDialog?.isOpen,
    belegId: (state: AppState) => state.previewDialog?.belegId,
    inhaberId: (state: AppState) => state.previewDialog?.inhaberId,
  };

  public static isOpen = createSelector(this.select.isOpen, identity);

  public static belegId = createSelector(this.select.belegId, identity);

  public static inhaberId = createSelector(this.select.inhaberId, identity);
}
